import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const ListaDisassegnazioniConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/statistiche/disassegnate',
      component: FuseLoadable({
        loader: () => import('./ListDisassegnazioni')
      })
    }
  ]
}
